// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconCartMobile = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20">
            <path
                fill="currentColor"
                d="M18.0898446,16.25 C17.0542973,16.25 16.2500006,17.0894527 16.2500006,18.125 C16.2500006,19.1605473 17.0894533,20 18.0898446,20 C19.0902358,20 19.9296886,19.1605473 19.9296886,18.125 C19.9296886,17.0894527 19.1601568,16.25 18.0898446,16.25 Z M6.83984458,16.25 C5.80429792,16.25 5.0000006,17.0894527 5.0000006,18.125 C5.0000006,19.1605473 5.83984435,20 6.83984458,20 C7.83984482,20 8.67968857,19.1605473 8.67968857,18.125 C8.67968857,17.0894527 7.91015685,16.25 6.83984458,16.25 Z M21.7526885,1.74726605 C21.5193481,1.43109322 21.1637051,1.25 20.7763959,1.25 L4.62555044,1.25 L4.56825626,0.762109756 C4.48422492,0.31992197 4.10608303,0 3.6668277,0 L0.882330507,0 C0.410608245,0 0,0.419921875 0,0.902343988 C0,1.3847661 0.410608245,1.875 0.882330507,1.875 L2.87387596,1.875 L5.17633777,14.2382812 C5.29398246,14.679687 5.67212378,15 6.11137911,15 L18.6397051,15 C19.1458036,15 19.5564119,14.5800781 19.5564119,14.097656 C19.5564119,13.5429692 19.147713,13.125 18.6397051,13.125 L6.87148158,13.125 L6.52007743,11.25 L18.6817193,11.25 C19.2275421,11.25 19.7069041,10.8800781 19.8570145,10.3433597 L21.9524529,2.87851572 C22.0582569,2.46289015 21.9856833,2.06367254 21.7526879,1.74726605 L21.7526885,1.74726605 Z"
            />
        </svg>
    );
};

export default React.memo(IconCartMobile);
